import { create_card_record, get_card_by_id, query_card_record_list } from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model2/mjstore/mjstore-cardrecord-config1';

import { reactive } from 'vue';
import { get_is_delete } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: '促销政策',
      disabled: false,
      placeholder: '请选择促销政策',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '购卡日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择购卡日期',
    },
    {
      type: 'remotemodal',
      name: 'delete_staff_id',
      label: '撤卡执行人',
      disabled: false,
      placeholder: '请选择撤卡执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    customer_id: null,
    staff_id: null,
    cxzc_id: null,
    shop_id: null,
    date: null,
    is_delete: false,
    is_now_num: true,
    delete_staff_id: null,
  }),
};
const search_options = {
  is_delete: [
    { value: None, name: '全部' },
    { value: True, name: '已撤卡' },
    { value: False, name: '未撤卡' },
  ],
};

// const is_disable_dict = ref({ 'total_num': false });
const edit_model_config = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'card_id',
      label: '卡',
      disabled: false,
      placeholder: '请选择卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-card',
    },
    {
      type: 'number',
      name: 'total_num',
      label: '项目次数',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写项目次数',
    },
    {
      type: 'number',
      name: 'single_price',
      label: '项目单价',
      disabled: true,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写单价',
    },
    {
      type: 'number',
      name: 'price',
      label: '项目金额',
      disabled: true,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写总价',
    },
    {
      type: 'number',
      name: 'czje',
      label: '充值使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写充值使用金额',
    },
    {
      type: 'number',
      name: 'flje',
      label: '返利使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写返利使用金额',
    },
    {
      type: 'number',
      name: 'zjfl',
      label: '直接返利',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写直接返利',
    },
    {
      type: 'number',
      name: 'zjje',
      label: '赠券使用金额',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      placeholder: '请填写赠券使用金额',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '购卡日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择购卡日期',
    },
    {
      type: 'remoteselect',
      name: 'cxzc_id',
      label: '促销政策',
      disabled: false,
      placeholder: '请选择促销政策',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-policy',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'input',
      name: 'mark',
      label: '备注',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写备注',
    },
  ],
  rules: {
    customer_id: [{ required: true, message: '请填输入会员姓名' }],
    card_id: [{ required: true, message: '请填输入卡' }],
    date: [{ required: true, message: '请填输入购卡日期' }],
    shop_id: [{ required: true, message: '请填输入执行门店' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    customer_id: null,
    card_id: null,
    total_num: null,
    single_price: null,
    price: null,
    czje: null,
    flje: null,
    zjfl: null,
    zjje: null,
    date: null,
    cxzc_id: null,
    shop_id: null,
    staff_id: null,
  }),
  watch: {
    single_price: (data: any) => {
      data.price = data.single_price * data.total_num;
    },
    total_num: (data: any) => {
      data.price = data.single_price * data.total_num;
    },
    card_id: (data: any, form: any) => {
      if (data['card_id'] > 0) {
        get_card_by_id({
          org_id: current_org.id,
          card_id: Number(data.card_id),
        }).then((res: any) => {
          if (res) {
            // is_disable_total_num.value = true;
            data.single_price = res.price;

            const f = form.fields.find((item: any) => {
              return item.name == 'total_num';
            });
            if (f) {
              data.total_num = 1;
              f.disabled = res.card_type == 11;
            }
          }
        });
      }
    },
  },
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '卡购买记录管理',
  addModalTitle: '新建卡购买记录',
  updateTitle: '修改卡购买记录',
  is_create: false, // 是否有【新建】按钮
  is_update: false, // 是否有【修改】按钮
  is_remove: false, // 是否有【删除】按钮
  is_recover: false, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    id: 'id',
  },
  delete: {
    id: 'id',
  },
  recover: {
    id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '卡号',
    width: 180,
    dataIndex: 'order_code',
    fixed: 'left',
    checked: true,
  },
  {
    title: '诉求号',
    width: 170,
    dataIndex: 'require_info__code',
    checked: true,
  },
  {
    title: '卡名称',
    width: 150,
    dataIndex: 'card__name',
    checked: true,
  },
  {
    title: '到期日期',
    width: 110,
    dataIndex: 'end_date',
    checked: true,
    slots: { customRender: 'date' },
  },
  {
    title: '卡余次',
    width: 80,
    dataIndex: 'now_num',
    checked: true,
  },
  {
    title: '卡次数',
    width: 80,
    dataIndex: 'total_num',
    checked: true,
  },
  {
    title: '单价',
    width: 80,
    dataIndex: 'single_price',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '卡金额',
    width: 80,
    dataIndex: 'price',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '充值使用金额',
    width: 110,
    dataIndex: 'czje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '返利使用金额',
    width: 110,
    dataIndex: 'flje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '直接返利',
    width: 110,
    dataIndex: 'zjfl',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '赠券使用金额',
    width: 110,
    dataIndex: 'zjje',
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '促销政策',
    width: 110,
    dataIndex: 'cxzc__name',
    checked: true,
  },
  {
    title: '转卡来源',
    width: 260,
    dataIndex: 'kzk_from',
    checked: true,
  },
  {
    title: '备注',
    width: 300,
    dataIndex: 'mark',
    checked: true,
  },
  {
    title: '所属顾问',
    width: 150,
    dataIndex: 'customer__adviser__name',
    checked: true,
  },
  {
    title: '执行门店',
    width: 75,
    dataIndex: 'shop__name',
    checked: true,
  },
  {
    title: '执行人',
    width: 75,
    dataIndex: 'staff__name',
    checked: true,
  },
  {
    title: '购卡日期',
    width: 150,
    dataIndex: 'date',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '激活状态',
    width: 135,
    dataIndex: 'used_status',
    checked: true,
    slots: { customRender: 'used_status' },
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '未激活', value: 0 },
      { text: '待激活', value: 1 },
      { text: '已激活', value: 2 },
    ],
  },
  {
    title: '执行情况',
    width: 150,
    dataIndex: 'is_now_num',
    checked: true,
    slots: { customRender: 'is_now_num' },
    filterMultiple: false,
    filters: [
      { text: '待执行', value: true },
      { text: '执行完', value: false },
    ],
  },
  {
    title: '单据状态',
    width: 150,
    dataIndex: 'is_active',
    checked: true,
    slots: { customRender: 'is_active' },
    filterMultiple: false,
    filters: [
      { text: '未作废', value: false },
      { text: '已作废', value: true },
    ],
    content: (record: any, text: any) => {
      return get_is_delete(text);
    },
  },
  {
    title: '确认日期',
    width: 135,
    dataIndex: 'receipt_datetime',
    checked: true,
    slots: { customRender: 'datetime' },
  },
  {
    title: '操作',
    width: 240,
    dataIndex: 'action',
    checked: true,
    slots: { customRender: 'action' },
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push(
  {
    type: 'custom',
    slotName: 'card_type',
    field_0: '次卡',
    field_1: '月卡',
    field_3: '季卡',
    field_12: '年卡',
  },
  {
    type: 'custom',
    slotName: 'used_status',
    field_0: '未激活',
    field_1: '待激活',
    field_2: '已激活',
  },
  { type: 'custom', slotName: 'is_delete', field_true: '已作废', field_false: '未作废' },
);
newSlotList.push({
  type: 'custom',
  slotName: 'is_now_num',
  field_true: '待执行',
  field_false: '执行完',
});
export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_card_record_list,
    addData: create_card_record,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
